import React, { Component } from "react";
import config from "../../config.json";
import httpService from "../../services/httpService";
import { Spinner, Accordion, Card, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { FaCheck, FaQrcode } from "react-icons/fa";
import EReceptLog from "./EReceptLog";
import authService from "../../services/authService";

class ERecept extends Component {
  state = {};

  componentDidMount = () => {
    this.nahrajRecepty();
  };

  componentWillUnmount = () => {
    if (this.repeat) {
      clearTimeout(this.repeat);
    }
  };

  nahrajRecepty = async () => {
    await this.setState({ loading: true });
    const recepty = await httpService.post(
      config.apiEndpoint + "erecept/vypis.php"
    );
    this.setState({
      recepty: recepty.data.recepty,
      loading: false,
      loaded: true
    });
    this.repeat = setTimeout(this.nahrajRecepty, 15000);
  };

  odeslat = async (cfg, confirmed) => {
    if (!confirmed) {
      if (window.confirm("Skutečně odeslat?")) {
        this.odeslat(cfg, true);
      }
    } else {
      let i = 0;
      let index = -1;
      let { recepty } = this.state;
      await this.setState({ odesilam: cfg });
      const recept = await httpService.post(
        config.apiEndpoint + "erecept/odeslat.php",
        { cfg }
      );
      if (recept.data && recept.data.odeslano) {
        for (i = 0; i < recept.data.odeslano.length; i++) {
          toast.success(recept.data.odeslano[i]);
        }
      }
      if (recepty && recept.data && recept.data.recepty) {
        for (i = 0; i < recept.data.recepty.length; i++) {
          index = recepty.findIndex(
            r => r.idpobytu === recept.data.recepty[i].idpobytu
          );
          if (index >= 0) {
            recepty[index] = recept.data.recepty[i];
          }
        }
        this.setState({ recepty });
      }
      this.setState({ odesilam: null });
    }
  };

  showModal = qr => {
    this.setState({ qr });
  };

  render() {
    const { recepty, loading, loaded, odesilam, qr, rand } = this.state;
    const user = authService.getCurrentUser();

    if (user.erecept !== "1") {
      return <div className="alert alert-danger">Nemáte sem přístup!</div>;
    }

    return (
      <React.Fragment>
        <Modal
          onHide={() => this.setState({ qr: null })}
          show={qr && qr.recept_id}
        >
          <Modal.Header closeButton>{qr && qr.erecept}</Modal.Header>
          <Modal.Body>
            {qr && <EReceptLog recept_id={qr.recept_id} rand={rand} />}
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-light"
              onClick={() => this.setState({ qr: null })}
            >
              Zavřít
            </button>
          </Modal.Footer>
        </Modal>
        {!loaded ? (
          loading && (
            <div className="text-warning">
              <Spinner animation="grow" size="sm" variant="warning" />
              Loading...
            </div>
          )
        ) : recepty && recepty.length > 0 ? (
          <React.Fragment>
            <Accordion>
              {recepty.map((r, index) => (
                <Card key={index}>
                  <Accordion.Toggle as={Card.Header} eventKey={index}>
                    {r.jmeno}{" "}
                    <span
                      className={
                        "badge badge-" +
                        (r.odeslano && r.odeslano > 0
                          ? r.odeslano === r.pocet
                            ? "success"
                            : "warning"
                          : "danger")
                      }
                    >
                      {r.pocet}
                    </span>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={index}>
                    <Card.Body>
                      {r.recepty.map((rr, index2) => (
                        <div key={index2}>
                          <h4>
                            {rr.datum}{" "}
                            <button
                              className="btn btn-primary"
                              onClick={() =>
                                this.odeslat({
                                  idpobytu: rr.idpobytu,
                                  datum: rr.datum_raw
                                })
                              }
                            >
                              Odeslat vše
                            </button>
                            {odesilam &&
                              odesilam.idpobytu === rr.idpobytu &&
                              odesilam.datum == rr.datum_raw && (
                                <Spinner
                                  animation="grow"
                                  style={{ marginLeft: "20px" }}
                                  variant="info"
                                />
                              )}
                          </h4>
                          <div className="row">
                            {rr.polozky.map((p, index3) => (
                              <div
                                className="col-md-3"
                                key={index3}
                                style={{
                                  marginTop: "10px",
                                  marginBottom: "10px"
                                }}
                              >
                                <Card>
                                  <Card.Header>
                                    {p.odeslano && (
                                      <span
                                        style={{ float: "right" }}
                                        className="text-success"
                                      >
                                        <FaCheck />
                                      </span>
                                    )}
                                    {p.erecept}
                                  </Card.Header>
                                  <Card.Body>
                                    <small>Lék</small>
                                    <div>{p.lek}</div>
                                    <small>Telefon</small>
                                    <div>
                                      {p.telefon !== "" ? (
                                        p.telefon
                                      ) : (
                                        <span className="text-danger">
                                          neuveden
                                        </span>
                                      )}
                                    </div>
                                    <small>Odesláno</small>
                                    <div>
                                      {p.odeslano ? (
                                        <a
                                          href="javascript:;"
                                          onClick={() =>
                                            this.setState({
                                              qr: p,
                                              rand: Math.random()
                                            })
                                          }
                                        >
                                          {p.odeslano}
                                        </a>
                                      ) : (
                                        <span className="text-danger">
                                          zatím ne
                                        </span>
                                      )}
                                    </div>
                                  </Card.Body>
                                  <Card.Footer>
                                    {odesilam &&
                                    odesilam.idpobytu === p.idpobytu &&
                                    (odesilam.erecept === p.erecept ||
                                      odesilam.datum === p.datum_raw) ? (
                                      <Spinner
                                        animation="grow"
                                        style={{ float: "right" }}
                                        variant="info"
                                      />
                                    ) : (
                                      <a
                                        className="btn btn-info btn-sm"
                                        style={{ float: "right" }}
                                        href={
                                          "https://www.epreskripce.cz/erp?i=" +
                                          p.erecept +
                                          "&s=" +
                                          p.platnost
                                        }
                                        target="_blank"
                                      >
                                        <FaQrcode />
                                      </a>
                                    )}
                                    <button
                                      className="btn btn-primary btn-sm"
                                      disabled={
                                        p.mobil === "" && p.telefon === ""
                                      }
                                      onClick={() =>
                                        this.odeslat({
                                          idpobytu: p.idpobytu,
                                          erecept: p.erecept
                                        })
                                      }
                                    >
                                      Odeslat
                                    </button>
                                  </Card.Footer>
                                </Card>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ))}
            </Accordion>
          </React.Fragment>
        ) : (
          <div className="alert alert-danger">Nic tu není...</div>
        )}
      </React.Fragment>
    );
  }
}

export default ERecept;
